import { useCollectionItem } from '@rocketlane/state-db';
import { projectCollection } from './project-collection';
/**
 * Reactive single-project read from the collection (O(1) per-id subscription).
 * Returns `undefined` until a detail/list fetch has populated this id.
 */ export const useProject = (projectId)=>useCollectionItem(projectCollection, projectId);
